export default {"src":"/_next/static/media/EstrelaBet.b732d955.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};